// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1AzyN"};